/** 
 * --- Device Module ---
 * Provides device type detection based on viewport width.
 * Updates flags for mobile, tablet, phone, and touch capabilities.
 * Event listeners ensure flags are updated on window resize and orientation change.
 */

function deviceCheck() {
    if ($(window).width() < tabletBreakpoint && $(window).width() >= phoneBreakpoint) {
        isMobile = true;
        isTablet = true;
        isPhone = false;
    }
    else if ($(window).width() < phoneBreakpoint) {
        isMobile = true;
        isPhone = true;
        isTablet = false;
    }
    else {
        isMobile = false;
        isTablet = false;
        isPhone = false;
    }
    if ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) {
        isTouch = true;
    }
    else {
        isTouch = false;
    }
}

$(window).on('resize', function () {
    changeEvents();
});

$(window).on('orientationchange', function () {
    changeEvents();
});